module.exports = __webpack_public_path__ + "h5/img/live-logo.20d83463.gif";